export default {
  club_name: 'Vita hästen',
  club_name_short: 'hasten',
  stadium_name: '',
  staging_url: 'https://hasten.api.fangroup.io',
  prod_url: 'https://hasten.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/hasten',
  club_logo: '/assets/teams/hasten.png',
  app_name: 'hasten',
  websale_name: 'hasten',
  ntb_team_id: 10025,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'hasten',
  monolithEnabled: false,
};
